import QuestionnaireMetricsTable from 'src/javascripts/components/tables/QuestionnaireMetricsTable';
import DefaultTable from 'src/javascripts/components/tables/DefaultTable';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import ScrollToTag from 'src/javascripts/components/nav/ScrollToTag';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {genericDisplayTemplate, logoTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');


export default class QuestionnairesMetricTablesIndex {

  constructor() {}

  render() {

	  // Set account id
	  const accountUrl = $('body').attr('data-account-url');

    // Set scroll and reload
    $('.reload-by-table').click(function() {
      let scrollFilter = $('#metricTablesBody').scrollTop();
      let metricTableId = $(this).data('metric-table-id');
      let url = '/' + accountUrl + '/questionnaires/metric_tables';
      let params = {};
      params['metric_table_id'] = metricTableId;
      params['sp'] = scrollFilter;
      Turbo.visit(url + '?' + $.param(params));
    })

    // Scroll templates container on load
    let p = $('#metricTablesBody').data("scroll-p");
    if (typeof p !== "undefined") {
      $('#metricTablesBody').scrollTop(p);
    }

	  // Questionnaires and companies search
    filterTypeahead('.portfolios-search', 'portfolios', '/' + accountUrl + '/portfolios/search?', 382, 'generic');

    // Render table
    if ( $('#questionnaire_metrics_table_wrapper').length === 0 ) {
      let table = new QuestionnaireMetricsTable($('#questionnaire_metrics_table'));
      $.when( table.render() ).then( status => table.setUp('questionnaire_metrics_table') )
    }

    // Expand sidebar on click
    $('#metric_tables_list .list-item').click(function() {
      let group = $(this).data('group');
      $('#metric_tables_list .list-item[data-group-parent="' + group + '"]').toggleClass('minimized');
    })

    // Search metric tables
    $("#search_data_tables").on("keyup", function() {
      let val = $(this).val().toLowerCase();
      $("#metric_tables_list .list-item").filter(function() {
        let t = $(this).data('table-name').toLowerCase();
        if (t.indexOf(val) === -1) {
          $(this).removeClass('d-flex').addClass('d-none');
        } else {
          $(this).removeClass('d-none').addClass('d-flex');
        }
      });
    });

    // Auto-focus on expanding dropdown
    $('.dropdown').on('shown.bs.dropdown', function() {
    	$(this).find('.typeahead').focus();
    });

    // Reload with attrs
    let reloadWithSelectedParams = function() {
	    let url = '/' + accountUrl + '/questionnaires/metric_tables';
      let params = {};
      params['portfolio_id'] = $('#questionnaire_metrics_table').attr('data-portfolio-id');
      params['metric_table_id'] = $('#questionnaire_metrics_table').attr('data-metric-table-id');
      params['full_view'] = $('#questionnaire_metrics_table').attr('data-full-view');
      params['detail_columns'] = $('#questionnaire_metrics_table').attr('data-detail-columns');
      params['excluded'] = $('#questionnaire_metrics_table').attr('data-excluded');
      params['data_types'] = $('#questionnaire_metrics_table').attr('data-data-types');
      Turbo.visit(url + '?' + $.param(params));
    }

    // On selecting an item
    $('.portfolios-search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      $('#questionnaire_metrics_table').attr('data-portfolio-id', suggestion.value);
      reloadWithSelectedParams();
    })

    // Exclude or include
    $('.exclude-selected-records').click(function() {
      let recordSym = []
      let exists = $('#questionnaire_metrics_table').attr('data-excluded');
      if (typeof exists !== 'undefined') {
        recordSym = exists.split(',');
      };
      $('#questionnaire_metrics_table input.checkbox:checked').each(function() {
        let r = $(this).closest('tr').attr('data-record-symbol');
        if (typeof r !== 'undefined') {recordSym.push(r);}
      })
      $('#questionnaire_metrics_table').attr('data-excluded', recordSym);
      reloadWithSelectedParams();
    })


  }

}